import { SET_PDF_IMAGE_BOXES } from "../actionTypes";
import { createAction } from "redux-starter-kit";

export const setPdfImageBoxesAction = createAction(SET_PDF_IMAGE_BOXES);
